// src/features/learner/components/ContentRenderers/MatchingRenderer.js
import React from 'react';
import MatchingViewer from '../../../units/MatchingViewer';

export const MatchingRenderer = ({
    unit,
    userAnswers,
    showFeedback,
    completedUnits,
    onAnswerSelect,
    onCheckAnswer,
    onMarkCompleted,
    onResetUnit, 
  
}) => {
    if (!unit) {
        return (
            <div className="unit-content">
                <p>No matching question available</p>
            </div>
        );
    }

    return (
        <div className="unit-content">
            <MatchingViewer
                unit={unit}
                userAnswers={userAnswers}
                showFeedback={showFeedback}
                completedUnits={completedUnits}
                onAnswerSelect={onAnswerSelect}
                onCheckAnswer={onCheckAnswer}
                onMarkCompleted={onMarkCompleted}
                onResetUnit={onResetUnit}
            />
        </div>
    );
};